/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putPreferences.defs.js'
export * as $defs from './putPreferences.defs.js'
